import { render, staticRenderFns } from "./Casual-worker.vue?vue&type=template&id=8c67e4ca&"
import script from "./Casual-worker.vue?vue&type=script&lang=js&"
export * from "./Casual-worker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports